import { AxiosResponse } from 'axios';
import axiosClient from './aixosClient';
import { BaseResponse } from 'models/gameModel';

const gameApi = {
    getBalance(): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosClient.get('account/get-balance');
    },
    getAllGame(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosClient.post('game-instance/all', payload);
    },
    getHistoryIssue(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosClient.post('game/list', payload);
    },
    getHistoryBet(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosClient.post('game/my-bet/list', payload);
    },
};
export default gameApi;
